export default __webpack_public_path__ + "static/media/madikeri_fort.394d815a.jpg";